import {
  AddLessonToUserGroupOperationRequest,
  AddLessonToUserGroupRequest,
} from "@revolutionrobotics/admin-api";
import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { UserGroupApi } from "../../services/configuration";
import { SetError } from "../../services/general";
import { ButtonWithStyle } from "../ButtonWithStyle";
import { FormItem } from "../FormItem";

interface AddNewLessonToUserGroupProps {
  id: string;
  setError: Function;
  refresh: Function;
}

export function AddNewLessonToUserGroup({
  id,
  setError,
  refresh,
}: AddNewLessonToUserGroupProps) {
  const [validated, setValidated] = useState(false);
  const [inputs, setInputs] = useState<any | null>(null);

  const handleSubmit = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);

    if (!inputs || !inputs.lessonId) return;

    const details: AddLessonToUserGroupRequest = {
      lessonId: inputs.lessonId,
    };
    const req: AddLessonToUserGroupOperationRequest = {
      id: id,
      request: details,
    };

    UserGroupApi.addLessonToUserGroup(req).then(
      () => {
        console.log("lesson has been updated.");
        refresh();
      },
      (error) => {
        SetError(error, setError);
      }
    );
  };

  const handleChange = (event: any) => {
    const value = event.target.value;
    const name = event.target.name;
    setInputs((values: any) => ({ ...values, [name]: value }));
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Col>
          <Row>
            <FormItem
              title={"Lesson Id"}
              type={"text"}
              required={true}
              name={"lessonId"}
              handleChange={handleChange}
            />
          </Row>
        </Col>
      </Row>

      <ButtonWithStyle buttonTitle="Create" type="submit" variant="primary" />
    </Form>
  );
}
